import { forwardRef } from 'react'
import { string, func } from 'prop-types'
import isURL from 'validator/es/lib/isURL'
import { css } from '@emotion/react'
import { Button } from '@livechat/design-system-react-components'

import { DEVELOPER_PAGE_TABS } from '@/constants'
import { sendEmail } from '@/utils/browser'
import Link from '@/components/Expert/Link'
import Section from '@/components/Product/Section'

const linksWrapperCss = css`
  display: flex;
  align-items: center;

  > p {
    margin-right: 4px;
  }
`

const buttonsWrapperCss = css`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-right: 8px;
`

const mailButtonWrapperCss = css`
  margin-right: 8px;
`

const Contact = ({
  github,
  website,
  twitter,
  innerRef,
  company,
  contactEmail,
}) => {
  const links = [
    { url: twitter, label: '\u0058' },
    { url: website, label: 'website' },
    { url: github, label: 'github' },
  ].filter(({ url }) => url && isURL(url, { require_protocol: true }))
  const linksExist = links?.length > 0

  return (
    <Section id={DEVELOPER_PAGE_TABS.CONTACT} ref={innerRef} title="Contact">
      <div>
        <p>
          Reach out to {company} for any assistance you need with the apps or
          the services.
        </p>

        <div css={buttonsWrapperCss}>
          {contactEmail && (
            <Button
              kind="primary"
              css={mailButtonWrapperCss}
              onClick={() => {
                sendEmail(contactEmail)
              }}
            >
              Send message
            </Button>
          )}
          {linksExist && (
            <div css={linksWrapperCss}>
              <p>{contactEmail ? `or visit` : `Visit`}</p>
              {links.map(({ url, label }, index) => {
                return (
                  <Link
                    key={label}
                    url={url}
                    label={label}
                    index={index}
                    linksLength={links.length}
                  />
                )
              })}
            </div>
          )}
        </div>
      </div>
    </Section>
  )
}

Contact.propTypes = {
  github: string,
  innerRef: func,
  website: string,
  twitter: string,
  company: string,
  contactEmail: string,
}

export default forwardRef((props, ref) => <Contact innerRef={ref} {...props} />)
